import type { AppRouteModule } from '/@/router/types';

const graphicText: AppRouteModule = {
  path: '/graphic-text',
  name: 'graphicText',
  component: () => import('/@/layouts/graphicText/index.vue'),
  meta: {},
  children: [
    {
      path: '/graphic-text/template',
      name: 'GraphicTextTemplate',
      meta: {
        title: '图文模板管理',
      },
      component: () => import('/@/views/graphic-text/template-manage/index.vue'),
    },
    {
      path: '/graphic-text/export',
      name: 'GraphicTextExport',
      meta: {
        title: '图文导出任务管理',
      },
      component: () => import('/@/views/graphic-text/export-manage/index.vue'),
    },
    {
      path: '/graphic-text/export/:id',
      name: 'GraphicTextExportTask',
      meta: {
        title: '图文导出任务详情',
      },
      component: () => import('/@/views/graphic-text/export-manage/task/index.vue'),
    },
    {
      path: '/graphic-text/font',
      name: 'GraphicTextFont',
      meta: {
        title: '图文字体管理',
      },
      component: () => import('/@/views/graphic-text/font-manage/index.vue'),
    },
    {
      path: 'member',
      name: 'GraphicTextMember',
      meta: {
        title: '成员管理',
      },
      props() {
        return {
          inviteUrlQuery: 'toCreation=2',
        };
      },
      component: () => import('/@/views/member/index.vue'),
    },
    {
      path: 'account',
      name: 'GraphicTextAccount',
      meta: {
        title: '账号中心',
      },
      component: () => import('/@/views/account/index.vue'),
    },
    {
      path: 'lingdou',
      name: 'GraphicTextLingdou',
      meta: {
        title: '灵豆记录',
      },
      component: () => import('/@/views/commerce/lingdou/index.vue'),
    },
  ],
};

export default graphicText;
